// extracted by mini-css-extract-plugin
export default {"root":"modal_root__5wlCc","content":"modal_content__0N7QI","body":"modal_body__tWMIl","footer":"modal_footer__iBBp9","header":"modal_header__BDt9p"};